import cx from 'classnames';
import { GatsbyImageProps } from 'gatsby-plugin-image';
import React from 'react';

import { Image } from '../../index';
import * as styles from './ImageBox.module.css';

const ImageBox = ({
	image,
	alt,
	type = 'box',
	as: Component = 'figure',
}: {
	image: GatsbyImageProps;
	alt: string;
	type?: 'box' | 'free';
	as?: React.ElementType;
}) => {
	return (
		<Component className={cx(styles[type])}>
			<Image image={image} alt={alt} fit="contain" />
		</Component>
	);
};

export default ImageBox;
